import type { ThemePalette } from '@shared-core/features/config'

// Safari на iOS кэширует theme-color: простой .content = часто не перекрашивает status bar.
// Пересоздаём meta без media, чтобы цвет chrome всегда совпадал с темой приложения.
function setSafariThemeColor(color: string): void {
  for (const node of document.querySelectorAll('meta[name="theme-color"]')) {
    node.remove()
  }

  const meta = document.createElement('meta')
  meta.name = 'theme-color'
  meta.content = color
  document.head.appendChild(meta)
}

export function applyCssThemeVariables(palette: ThemePalette): void {
  if (typeof document === 'undefined') return

  document.documentElement.dataset.theme = palette
  document.documentElement.style.colorScheme = palette

  // Сначала тема в DOM, потом читаем --color-bg-base уже для нужной палитры.
  const background = getComputedStyle(document.documentElement).getPropertyValue('--color-bg-base').trim()

  if (!background) return

  const foreground = palette === 'dark' ? '#ffffff' : '#09090b'

  // Фон html/body виден за полупрозрачным status bar (viewport-fit=cover).
  document.documentElement.style.backgroundColor = background
  document.documentElement.style.setProperty('--splash-bg', background)
  document.documentElement.style.setProperty('--color-primary', foreground)
  document.body.style.backgroundColor = background
  setSafariThemeColor(background)
}
